export default __webpack_public_path__ + "images/bca91a089d28b3343a66b2e8ccd4b665-investment.webp";